<form [formGroup]="form" autocomplete="off">
  <section>
    <div class="row tw-p-4">
      <!-- field -->
      <div class="tw-w-full">
        <custom-select-search
          [isDisabled]="isFromModal ? false : true"
          [label]="'common.field'"
          class="tw-w-full"
          optionValue="id"
          optionTitle="optionTitle"
          [items]="formBuilderFieldsList"
          [removable]="false"
          [value]="model.formBuilderFieldId"
          (itemChange)="onChangeFields($event)"
          [isShowValidationStatusIcon]="isFromModal ? true : false"
        >
        </custom-select-search>
      </div>

      <div
        class="tw-mb-5"
        *ngIf="model.fieldType == formBuilderFieldTypes.SelectList"
      >
        <p class="tw-text-2xl tw-text-center dark:tw-text-gray-100">
          {{ "common.items" | translate }}
        </p>
        <div
          class="tw-my-1 tw-rounded-md"
          *ngFor="let option of model.selectListOptions || selectListOptions"
        >
          <div
            class="list-group-item tw-border tw-border-gray-100 dark:tw-border-dark-100 dark:tw-bg-dark-300 tw-rounded-md tw-flex tw-justify-between tw-items-center tw-h-[50px] bg-light rounded"
          >
            <span
              class="tw-text-gray-800 dark:tw-text-gray-300 dark:tw-border-dark-100 tw-font-medium"
            >
              {{ option }}</span
            >
          </div>
        </div>
      </div>

      <app-form-fields-validations
        fieldsClass="tw-w-full"
        [fieldType]="model.fieldType"
        [isEditMode]="formPageConfig.isEditMode"
        [(model)]="model.validation"
        (modelChange)="emitModel()"
      ></app-form-fields-validations>

      <!-- description -->
      <div class="tw-w-full">
        <form-textarea
          class="tw-w-full"
          label="common.description"
          [(value)]="model.description"
          [control]="form?.get('description')"
          (valueChange)="emitModel()"
          [rows]="2"
        >
        </form-textarea>
      </div>

      <!-- isRequired -->
      <div class="tw-w-full">
        <mat-slide-toggle
          formControlName="isRequired"
          [(ngModel)]="model.isRequired"
          (change)="emitModel()"
        >
          {{ "common.isRequired" | translate }}
        </mat-slide-toggle>
      </div>
    </div>
  </section>
</form>
